import {http} from './config';

export default {
    sendNotifyUser: (id, link) => {
        return http.post('api/v1/clientes/notificacao/usuario', {id, link});
    },
    getResumClientSex(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/sexo',{params:{allotmentId:allotmentId}});
    },
    getResumClientType(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/type',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveSex(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/sexo',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveType(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/type',{params:{allotmentId:allotmentId}});
    },
    getResumClientAge(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/idade',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveAge(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/idade',{params:{allotmentId:allotmentId}});
    },
    getResumClientMaritalStatus(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/estadoscivis',{params:{allotmentId:allotmentId}});
    },
    getResumClientState(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/estado',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveState(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/estado',{params:{allotmentId:allotmentId}});
    },
    getResumClientIncome(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/rendaMensal',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveIncome(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/rendaMensal',{params:{allotmentId:allotmentId}});
    },
    getResumClientCity(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/cidades',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveCity(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/cidades',{params:{allotmentId:allotmentId}});
    },
    getResumClientProfession(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/pessoas/profissao',{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveProfession(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/profissao',{params:{allotmentId:allotmentId}});
    },
    getResumClientNeighborhood(allotmentId, city, state) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get(`api/v1/dashboard/pessoas/bairro?cityName=${city}&state=${state}`,{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveNeighborhood(allotmentId, city, state) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get(`api/v1/dashboard/cliente/bairro?cityName=${city}&state=${state}`,{params:{allotmentId:allotmentId}});
    },
    getResumClientReserveMaritalStatus(allotmentId) {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        return http.get('api/v1/dashboard/cliente/estadoscivis',{params:{allotmentId:allotmentId}});
    },
    create: (client) => {
        return http.post('api/v1/clientes', client);
    },
    dashboard: (allotmentId, dateS = null , dateE = null) => {
        if (allotmentId === 'nenhum' || allotmentId === 'selecione') allotmentId = null;
        if (dateS && dateE) return http.get('api/v1/dashboard/clientes',{params:{allotmentId, dateS, dateE}});
        return http.get('api/v1/dashboard/clientes',{params:{allotmentId}});
    },
    exportPdfClient: (id) => {
        return http.get('api/v1/exportar/pessoas/pdf', {
            params: {"0": id},
        });
    },
    exportPdfClientArray: (array) => {
        return http.get('api/v1/exportar/pessoas/pdf', {
            params: array,
        });
    },
    show: (id) => {
        return http.get('api/v1/clientes/' + id);
    },
    index: (page = 1, filter, perpage = null, filters = {}) => {
        if (perpage === 'selecione') perpage = null;
        if (filters?.allotment_id && filters.allotment_id === 'selecione') filters.allotment_id = null;
        return http.get('api/v1/clientes?page=' + page, {params: {...filter, perpage, filters}});
    },
    delete: (id) => {
        return http.delete('api/v1/clientes/' + id);
    },
    showByTaxpayer: (taxpayer) => {
        return http.get('api/v1/clientes/ver/' + taxpayer);
    },
    showByTaxpayerPublic: (taxpayer,companyId) => {
        return http.get('api/v1/publica/clientes/ver/' + taxpayer,{headers:{'company-id': companyId}});
    },
    update: (client) => {
        return http.put('api/v1/clientes/' + client.id, client);
    },
    showWhenCreate: (taxpayer) => {
        return http.get(`api/v1/clientes/show/${taxpayer}`);
    },
    listProfessions: () => {
        return http.get(`api/v1/profissoes/listar`);
    },
    listClientsToSales: (term) => {
        if (!term) {
            return http.get('api/v1/clientes/list');
        }
        return http.get('api/v1/clientes/list?term=' + term);
    },
    importFile: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return http.post('api/v1/importar/pessoas', formData);
    },
    exportFile: (filterExport = {}) => {
        return http.get('/api/v1/exportar/pessoas', {responseType: 'blob', params:{filterExport}});
    },
    numberValid: (number) => {
        return http.post("/api/v1/clientes/numberIsValid", {number: `55${number}`});
    },
    numberValidPublic: (number) => {
        return http.post("/api/v1/publica/clientes/numberIsValid", {number: `55${number}`});
    }
}
